import { bool } from "prop-types";

import styled from "styled-components/macro";

import { useGetNetworkMetadata } from "Flocknote/API/queries";
import { useNetworkMetadata } from "Flocknote/apiHooks";
import { useIsSuperDuper } from "Flocknote/stateHooks";

import { useTopAreaRef } from "NavBar/navBarStore";
import { useGoToActionCenter, useIsFullScreen } from "NavBar/stateHooks";
import { springAnimation } from "NavBar/styleConstants";

import FnrButtonWrapper from "UI/FnrButtonWrapper";
import FnrOpacityToggle from "UI/FnrOpacityToggle";
import FnrTypography from "UI/FnrTypography";

import NetworkIDPill from "./NetworkIDPill";
import NetworkPhoto from "./NetworkPhoto";
import ParentNetLink from "./ParentNetLink";
import Toolbar from "./Toolbar";

const TopArea = ({ isNavToolbar = false }) => {
  const [{ networkName }] = useNetworkMetadata();
  const isSuperDuper = useIsSuperDuper();
  const isFullScreen = useIsFullScreen();
  const { isFetched } = useGetNetworkMetadata();

  const topAreaRef = useTopAreaRef();
  const goToActionCenter = useGoToActionCenter();

  const handleNetworkNameClick = () => {
    goToActionCenter();
  };

  return (
    <Wrapper
      data-cy="NavBar_TopArea"
      ref={topAreaRef}
      show={isFetched}
      transition={springAnimation}
    >
      <RowWrapper>
        <NetworkPhoto />
        <NetworkNameWrapper
          data-cy="NavBar_TopArea_NetworkName"
          aria-label="Go to Action Center"
          onClick={handleNetworkNameClick}
        >
          <SFnrOpacityToggle show>
            <FnrTypography
              type="header"
              fontWeight={400}
              bold={false}
              color="textLight"
              fontSize="xl"
              lineHeight={1.1}
              noWrap={false}
            >
              {networkName}
            </FnrTypography>
          </SFnrOpacityToggle>
          {isSuperDuper && <NetworkIDPill />}
        </NetworkNameWrapper>
      </RowWrapper>

      <ParentNetLink />

      {!isFullScreen && <Toolbar isNavToolbar={isNavToolbar} />}
    </Wrapper>
  );
};

TopArea.propTypes = { isNavToolbar: bool };

const NetworkNameWrapper = styled(FnrButtonWrapper)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;

  span {
    width: 100%;
    overflow-wrap: break-word;
  }
`;

const SFnrOpacityToggle = styled(FnrOpacityToggle)`
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  min-width: 0;
`;

const Wrapper = styled(FnrOpacityToggle)`
  display: flex;
  flex-direction: column;
  padding: 12px 12px 0px 12px;
`;

const RowWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export default TopArea;
